import dayjs from 'dayjs'
import React from 'react'
// import { TimeField } from '@mui/x-date-pickers/TimeField';




const TimeFields = (props: any) => {
  const {node, data, change} = props;
  return (

    // <TimeField
    //       label="Format with seconds"
    //       defaultValue={dayjs('2022-04-17T15:30')}
    //       format="HH:mm:ss"
    //     />
    <div className='flex flex-col gap-1.5 p-2'>
      <div className=' text-base text-[#292D32]'>{node.title}</div>
      <input id="timeField" className=' rounded-[4px] border border-[#E5E5E5] px-3 py-2.5' type="time" name="timeField" step="2" />
    </div>

  )
}

export default TimeFields